import React, {useEffect, useState} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import axios from "axios";
import {ILoginRequest} from "../../data/interfaces/ILoginRequest";
import {SurveyService} from "../../data/services/SurveyService";
import {SurveyApi} from "../../data/api/SurveyApi";
import "./style.scss";


export function LoginView() {

    const [searchParams, setSearchParams] = useSearchParams();

    const navigate = useNavigate();

    const surveyService = SurveyService();

    const [loaded, setLoaded] = useState(false);
    const [email, setEmail] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [loginErrorMessage, setLoginErrorMessage] = useState<string | undefined>(undefined);

    const login = async () => {
        const request = { email, password } as ILoginRequest;
        const response = await surveyService.login(request);
        if(response) {
            localStorage.setItem('user', email);
            navigate(searchParams.get('requestedPage') ?? "/")
        }
        else {
            setLoginErrorMessage("Не удалось выполнить вход. Провертье правильность введенных данныхю");
        }
    }


    useEffect(() => {
        const user = localStorage.getItem('user');
        if(user != null) {
            navigate(searchParams.get('requestedPage') ?? "/")
        }
        setLoaded(true);
    }, []);


    return (
        <>
            {
                loaded && (
                    <div className="login-form-wrapper">

                        <div className="login-form-container">

                            <div className="login-form">
                                <div className="login-form-header">Вход в систему</div>

                                <div className="login-form-body">

                                    {
                                        loginErrorMessage !== undefined && (
                                            <div className="login-form-error-message">
                                                {loginErrorMessage}
                                            </div>
                                        )
                                    }

                                    <div className="login-form-text-field-container">

                                        <input
                                            type="text"
                                            className="login-form-input"
                                            placeholder="Email"
                                            value={email}
                                            onChange={(event) => {
                                                setEmail(event.target.value);
                                            }}
                                        />

                                        <input
                                            type="password"
                                            className="login-form-input"
                                            placeholder="Пароль"
                                            style={{marginTop: "10px"}}
                                            value={password}
                                            onChange={(event) => {
                                                setPassword(event.target.value);
                                            }}
                                        />

                                    </div>

                                    <button
                                        type="button"
                                        className="login-form-btn"
                                        disabled={(email.trim().length === 0 || password.trim().length === 0)}
                                        onClick={() => login()}
                                    >
                                        Вход
                                    </button>

                                </div>

                            </div>

                        </div>

                    </div>
                )
            }
        </>
    );
}